<template>
	<AoBtn
		class="action-button"
		:stacked="stacked"
		:iconSize="20"
		:prependIconName="iconName"
		:color="color"
		:rounded="rounded"
		@click="$emit('click')"
	>
		<span class="action-button__label">{{ label }}</span>
		<v-badge
			v-if="badge"
			class="action-button__badge"
			location="top right"
			:color="`status-${badgeStatusColor}-lighten-3`"
			:content="badge"
		/>
	</AoBtn>
</template>

<script setup>
import AoBtn from '../AoBtn.vue'

defineProps({
	// unique identifier
	type: {
		type: String,
	},
	iconName: {
		type: String,
	},
	label: {
		type: String,
	},
	badge: {
		type: [String, Number],
	},
	badgeStatusColor: {
		type: [String, Number],
		validator: (v) => ['success', 'warning', 'danger', 'info'].includes(v),
	},
	stacked: {
		type: Boolean,
	},
	color: {
		type: String,
	},
	rounded: {
		type: Boolean,
	},
})

defineEmits({
	click: null,
})
</script>

<style lang="scss">
.action-button {
	color: #576674;
	box-shadow: none;

	&__label {
		font-size: 10px;
		color: #576674;
	}

	&__badge {
		position: absolute;
		top: 0;
		right: 10px;
	}

	&:hover {
		color: rgb(var(--v-theme-primary-lighten-1));

		.action-button__label {
			color: rgb(var(--v-theme-primary-lighten-1));
		}
	}
}
</style>
